import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { CheckCircle2, Link2 } from 'lucide-react'
import { useToast } from '@/components/ui/use-toast'
import { cn } from '@/lib/utils'

export const SectionHeader = ({
	id,
	children,
	className = 'text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6',
}: {
	id: string
	children: React.ReactNode
	className?: string
}) => {
	const { toast } = useToast()
	const [copied, setCopied] = useState(false)

	const handleCopyLink = () => {
		const url = `${window.location.origin}${window.location.pathname}#${id}`
		navigator.clipboard
			.writeText(url)
			.then(() => {
				setCopied(true)
				toast({
					title: 'Link Copied!',
					description: 'You can now share this direct link to the section.',
				})
				setTimeout(() => setCopied(false), 2000)
			})
			.catch(() => {
				toast({
					title: 'Error',
					description: 'Failed to copy link',
					variant: 'destructive',
				})
			})
	}

	return (
		<div className="group flex items-center gap-3 mb-6">
			<h2 id={id} className={className}>
				{children}
			</h2>
			<Button
				onClick={handleCopyLink}
				variant="ghost"
				size="sm"
				className={cn(
					'opacity-0 group-hover:opacity-100 transition-opacity duration-200',
					copied && 'opacity-100'
				)}>
				{copied ? (
					<CheckCircle2 className="h-4 w-4 text-green-600" />
				) : (
					<Link2 className="h-4 w-4" />
				)}
			</Button>
		</div>
	)
}